import React from 'react';
import Text from '../Text/Text';
import './ActionButton.css';

interface ActionButtonProps {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
  className?: string;
  disabled?: boolean;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  icon,
  label,
  onClick,
  className = '',
  disabled = false
}) => {
  const baseClass = 'action-button';
  const combinedClassName = `${baseClass} ${className}`;
  
  return (
    <button 
      className={combinedClassName}
      onClick={onClick}
      disabled={disabled}
    >
      <div className="action-button-icon">
        {icon}
      </div>
      <Text className="text-body">{label}</Text>  
    </button>
  );
};

export default ActionButton;